// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --navbar-Height: 80px;

  --bg-primary-Clr: #f25d2c;
  --bg-primary-clr: #1e4f6c;
  --text-primary-clr: #1e4f6c;
  --text-secondary-clr: #f25d2c;
  --text-black-Clr: #050505;
  --btn-primary-clr: #f25d2c;

  --btn-secondary-clr: #1e4f6c;
  --btn-secondary-HOVER: #134664;
  --paragraph-font-size: 15px;
  --heading1-size: 4rem;
  --heading2-size: 3rem;
}

.nav-logo {
  width: 200px;
}

.nav-logo img {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
}

.nav-bar {
  position: fixed;
  width: 100%;
  height: var(--navbar-Height);
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* background: rgba(255, 255, 255, 0);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); */
  backdrop-filter: blur(4.5px);
  -webkit-backdrop-filter: blur(4.5px);
  z-index: 10;
  /* box-shadow: 0px 2px 3.6px rgba(0, 0, 0, 0.028),
    0px 5.6px 10px rgba(0, 0, 0, 0.039), 0px 13.6px 24.1px rgba(0, 0, 0, 0.051),
    0px 45px 80px rgba(0, 0, 0, 0.09); */
}
.navhead{
  color: black;
}
.navhead-bg{
  color: white;
}
#navhead{
  color: black;
}
#navhead-bg{
  color: white;
}

.navbar-bg{
  position: fixed;
  width: 100%;
  height: var(--navbar-Height);
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  z-index: 10;

}

.nav-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nav-item li {
  padding: 5px 15px;
}

.nav-item li a {
  font-weight: 500;

  text-decoration: none;
  position: relative;
}

.nav-item li a::after {
  color: #292929;
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0%;
  height: 2px;
  border-radius: 100%;
  background-color: var(--bg-primary-Clr);
  transition: all 0.45s;
}

.nav-item li a:hover::after {
  width: 100%;
}

.nav-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .dropdown-menu button{
    color: black;
    background-color: transparent;
} */

.dropdown-menu {
  color: #000000;
  position: relative;
  display: inline-block;
}

.dropdown-button {
  /* background-color: #4CAF50; */
  color: rgb(0, 0, 0);
  text-align: right;
  padding: 10px 12px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.dropdown-list {
  display: none;
  position: absolute;
  left: -600px;

  z-index: 1;
  background-color: #ffffff;
  min-width: 900px;

  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  border: 1px solid rgb(221, 221, 221);
  justify-content: space-evenly;
  padding: 7px 0;
}

.dropdown-list li {
  color: rgb(0, 0, 0);
  width: 250px;
  padding: 5px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
  border-bottom: 1px solid rgb(189, 189, 189);
  /* border-radius: 10px; */
}

.dropdown-list li a {
  font-size: 14px;
  font-weight: 400;
}

.dropdown-list li a:hover {
  font-weight: 500;
  transition: 0.8s;
  padding-left: 5px;
}

.down-aero {
  margin-bottom: -3px;
  color: #f25d2c !important;
}

.dropdown-list li:hover {
  background-color: #eeeeee;
  border-radius: 5px;
  transition: 0.8s;
}

.dropdown-menu:hover .dropdown-list {
  display: flex;
  flex-wrap: wrap;
}

.dropdown-menu:hover .dropdown-button {
  background-color: #eeeeee;
  border-radius: 4px;
  transform: translateY(-10%);
  transition: all 0.5s ease-in-out;
}

.dropdown-menu button {
  background: transparent;
}

.mobile-view {
  display: none;
}

/* ICONBAR End */

/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width: 1023px) {
  .nav-item {
    align-items: flex-end;
  }

  .login-btn {
    margin: 15px 15px;
    font-size: 14px;

    font-weight: 400;
  }

  .nav-logo {
    width: 250px;
    z-index: -9;
  }

  .nav-bar {
    width: 100%;
    position: fixed;
    background-color: white;
  }

  .nav-item {
    position: absolute;

    top: 100%;
    right: -150%;
    flex-direction: column;
    width: 60%;
    padding-right: 0px;
    padding-top: 10px;
    text-align: end;
    height: 90vh;
    /* top: var(--navbar-Height); */
    /* justify-content: center; */
    /* align-items: center; */
    /* height: calc(100vh - var(--navbar-Height)); */
    transition: all 0.45s;
    z-index: -1;
  }

  .nav-item.active {
    margin-top: var(--navbar-Height);
    top: 0;
    right: 0;
    z-index: -2;
  }

  .nav-item::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 95vh;
    background-color: var(--bg-primary-clr);
    opacity: 0.97;
    z-index: -57;
    box-shadow: 0px 30.5px 33.3px rgba(0, 0, 0, 0.343),
      0px 102.5px 111.7px rgba(0, 0, 0, 0.507),
      0px 459px 500px rgba(0, 0, 0, 0.85);
  }

  .nav-item li a {
    color: rgb(255, 255, 255);
    font-weight: 400;
    font-size: 1rem;
    line-height: 20px;
  }

  .menu-icon {
    z-index: 101;
    position: relative;
  }

  .menu-icon .bar {
    width: 32px;
    height: 5px;
    border-radius: 4px;
    background-color: var(--bg-primary-clr);
    transition: all 0.25s ease-in-out;
  }

  .menu-icon .bar::before,
  .menu-icon .bar::after {
    content: "";
    position: absolute;
    background-color: var(--bg-primary-clr);
    height: 5px;
    border-radius: 4px;
    transition: all 0.25s ease-in-out;
  }

  .menu-icon .bar::before {
    width: 25px;
    transform: translateY(-8px);
    right: 0;
  }

  .menu-icon .bar::after {
    width: 32px;
    transform: translateY(8px);
  }

  .menu-icon.active .bar {
    transform: translateX(-10px);
    background: transparent;
  }

  .menu-icon.active .bar::before {
    width: 32px;
    transform: rotate(45deg);
    /* transform:  translate(26px -26px); */
  }

  .menu-icon.active .bar::after {
    transform: rotate(-45deg);
    /* transform:  translate(26px -26px); */
  }

  .dropdown-list {
    position: relative;
    display: block;
  }

  .dropdown-list li a {
    color: #000000;
  }

  .dropdown-button {
    color: #ffffff;
  }

  .dropdown-list li {
    font-size: 10px;
  }

  .nav-item li {
    width: 100%;
    padding: 7px 15px;
    border-bottom: 1px solid #486270;
  }

  /* for solution diffrent view web and mobile */
  .mobile-view {
    display: initial;
  }

  .web-view {
    display: none;
  }
}

/* Responsive For Tablet Screen size 601px to 1023px END */

/*  */
/*  */
/* Responsive For Mobile Screen size 1024px to 1920px START */

@media (max-width: 767px) {
  .nav-logo {
    width: 200px;
  }

  /* .nav-bar {
        width: ;
    } */
}

/* Responsive For Mobile Screen size 1024px to 1920px END */
`, "",{"version":3,"sources":["webpack://./src/Components/Navbarstyles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;;EAErB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;;EAE1B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB;qDACmD;EACnD,4BAA4B;EAC5B,oCAAoC;EACpC,WAAW;EACX;;wCAEsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;;EAEhB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;;EAEZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;;EAEhB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;;AAEhB,4DAA4D;AAC5D;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,eAAe;;IAEf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;;IAElB,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;IAC7B,yBAAyB;IACzB,gDAAgD;IAChD,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,MAAM;IACN,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,aAAa;IACb,YAAY;IACZ;;yCAEqC;EACvC;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,uCAAuC;IACvC,iCAAiC;EACnC;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,uCAAuC;IACvC,WAAW;IACX,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,uCAAuC;EACzC;;EAEA;IACE,yBAAyB;IACzB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA,8CAA8C;EAC9C;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,0DAA0D;;AAE1D,KAAK;AACL,KAAK;AACL,6DAA6D;;AAE7D;EACE;IACE,YAAY;EACd;;EAEA;;OAEK;AACP;;AAEA,2DAA2D","sourcesContent":[":root {\n  --navbar-Height: 80px;\n\n  --bg-primary-Clr: #f25d2c;\n  --bg-primary-clr: #1e4f6c;\n  --text-primary-clr: #1e4f6c;\n  --text-secondary-clr: #f25d2c;\n  --text-black-Clr: #050505;\n  --btn-primary-clr: #f25d2c;\n\n  --btn-secondary-clr: #1e4f6c;\n  --btn-secondary-HOVER: #134664;\n  --paragraph-font-size: 15px;\n  --heading1-size: 4rem;\n  --heading2-size: 3rem;\n}\n\n.nav-logo {\n  width: 200px;\n}\n\n.nav-logo img {\n  width: 100%;\n  height: auto;\n  display: flex;\n  align-items: center;\n}\n\n.nav-bar {\n  position: fixed;\n  width: 100%;\n  height: var(--navbar-Height);\n  padding: 0 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  /* background: rgba(255, 255, 255, 0);\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); */\n  backdrop-filter: blur(4.5px);\n  -webkit-backdrop-filter: blur(4.5px);\n  z-index: 10;\n  /* box-shadow: 0px 2px 3.6px rgba(0, 0, 0, 0.028),\n    0px 5.6px 10px rgba(0, 0, 0, 0.039), 0px 13.6px 24.1px rgba(0, 0, 0, 0.051),\n    0px 45px 80px rgba(0, 0, 0, 0.09); */\n}\n.navhead{\n  color: black;\n}\n.navhead-bg{\n  color: white;\n}\n#navhead{\n  color: black;\n}\n#navhead-bg{\n  color: white;\n}\n\n.navbar-bg{\n  position: fixed;\n  width: 100%;\n  height: var(--navbar-Height);\n  padding: 0 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: white;\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n  z-index: 10;\n\n}\n\n.nav-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.nav-item li {\n  padding: 5px 15px;\n}\n\n.nav-item li a {\n  font-weight: 500;\n\n  text-decoration: none;\n  position: relative;\n}\n\n.nav-item li a::after {\n  color: #292929;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 0%;\n  height: 2px;\n  border-radius: 100%;\n  background-color: var(--bg-primary-Clr);\n  transition: all 0.45s;\n}\n\n.nav-item li a:hover::after {\n  width: 100%;\n}\n\n.nav-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* .dropdown-menu button{\n    color: black;\n    background-color: transparent;\n} */\n\n.dropdown-menu {\n  color: #000000;\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-button {\n  /* background-color: #4CAF50; */\n  color: rgb(0, 0, 0);\n  text-align: right;\n  padding: 10px 12px;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.dropdown-list {\n  display: none;\n  position: absolute;\n  left: -600px;\n\n  z-index: 1;\n  background-color: #ffffff;\n  min-width: 900px;\n\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  border: 1px solid rgb(221, 221, 221);\n  justify-content: space-evenly;\n  padding: 7px 0;\n}\n\n.dropdown-list li {\n  color: rgb(0, 0, 0);\n  width: 250px;\n  padding: 5px 16px;\n  text-decoration: none;\n  display: block;\n  cursor: pointer;\n  border-bottom: 1px solid rgb(189, 189, 189);\n  /* border-radius: 10px; */\n}\n\n.dropdown-list li a {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.dropdown-list li a:hover {\n  font-weight: 500;\n  transition: 0.8s;\n  padding-left: 5px;\n}\n\n.down-aero {\n  margin-bottom: -3px;\n  color: #f25d2c !important;\n}\n\n.dropdown-list li:hover {\n  background-color: #eeeeee;\n  border-radius: 5px;\n  transition: 0.8s;\n}\n\n.dropdown-menu:hover .dropdown-list {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dropdown-menu:hover .dropdown-button {\n  background-color: #eeeeee;\n  border-radius: 4px;\n  transform: translateY(-10%);\n  transition: all 0.5s ease-in-out;\n}\n\n.dropdown-menu button {\n  background: transparent;\n}\n\n.mobile-view {\n  display: none;\n}\n\n/* ICONBAR End */\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width: 1023px) {\n  .nav-item {\n    align-items: flex-end;\n  }\n\n  .login-btn {\n    margin: 15px 15px;\n    font-size: 14px;\n\n    font-weight: 400;\n  }\n\n  .nav-logo {\n    width: 250px;\n    z-index: -9;\n  }\n\n  .nav-bar {\n    width: 100%;\n    position: fixed;\n    background-color: white;\n  }\n\n  .nav-item {\n    position: absolute;\n\n    top: 100%;\n    right: -150%;\n    flex-direction: column;\n    width: 60%;\n    padding-right: 0px;\n    padding-top: 10px;\n    text-align: end;\n    height: 90vh;\n    /* top: var(--navbar-Height); */\n    /* justify-content: center; */\n    /* align-items: center; */\n    /* height: calc(100vh - var(--navbar-Height)); */\n    transition: all 0.45s;\n    z-index: -1;\n  }\n\n  .nav-item.active {\n    margin-top: var(--navbar-Height);\n    top: 0;\n    right: 0;\n    z-index: -2;\n  }\n\n  .nav-item::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 95vh;\n    background-color: var(--bg-primary-clr);\n    opacity: 0.97;\n    z-index: -57;\n    box-shadow: 0px 30.5px 33.3px rgba(0, 0, 0, 0.343),\n      0px 102.5px 111.7px rgba(0, 0, 0, 0.507),\n      0px 459px 500px rgba(0, 0, 0, 0.85);\n  }\n\n  .nav-item li a {\n    color: rgb(255, 255, 255);\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 20px;\n  }\n\n  .menu-icon {\n    z-index: 101;\n    position: relative;\n  }\n\n  .menu-icon .bar {\n    width: 32px;\n    height: 5px;\n    border-radius: 4px;\n    background-color: var(--bg-primary-clr);\n    transition: all 0.25s ease-in-out;\n  }\n\n  .menu-icon .bar::before,\n  .menu-icon .bar::after {\n    content: \"\";\n    position: absolute;\n    background-color: var(--bg-primary-clr);\n    height: 5px;\n    border-radius: 4px;\n    transition: all 0.25s ease-in-out;\n  }\n\n  .menu-icon .bar::before {\n    width: 25px;\n    transform: translateY(-8px);\n    right: 0;\n  }\n\n  .menu-icon .bar::after {\n    width: 32px;\n    transform: translateY(8px);\n  }\n\n  .menu-icon.active .bar {\n    transform: translateX(-10px);\n    background: transparent;\n  }\n\n  .menu-icon.active .bar::before {\n    width: 32px;\n    transform: rotate(45deg);\n    /* transform:  translate(26px -26px); */\n  }\n\n  .menu-icon.active .bar::after {\n    transform: rotate(-45deg);\n    /* transform:  translate(26px -26px); */\n  }\n\n  .dropdown-list {\n    position: relative;\n    display: block;\n  }\n\n  .dropdown-list li a {\n    color: #000000;\n  }\n\n  .dropdown-button {\n    color: #ffffff;\n  }\n\n  .dropdown-list li {\n    font-size: 10px;\n  }\n\n  .nav-item li {\n    width: 100%;\n    padding: 7px 15px;\n    border-bottom: 1px solid #486270;\n  }\n\n  /* for solution diffrent view web and mobile */\n  .mobile-view {\n    display: initial;\n  }\n\n  .web-view {\n    display: none;\n  }\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n/*  */\n/*  */\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n\n@media (max-width: 767px) {\n  .nav-logo {\n    width: 200px;\n  }\n\n  /* .nav-bar {\n        width: ;\n    } */\n}\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
